const re = /^dotenv_config_(encoding|path|debug|override|DOTENV_KEY)=(.+)$/

module.exports = function optionMatcher (args) {
  return args.reduce(function (acc, cur) {
    const matches = cur.match(re)
    if (matches) {
      acc[matches[1]] = matches[2]
    }
    return acc
  }, {})
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/dotenv/lib/cli-options.js
// module id = 1801
// module chunks = 0